import { Navigate } from 'react-router-dom'
import { useAuth } from '../lib/useAuth'

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0e1116',
        color: '#9aa6b0',
        fontFamily: "'Saira Condensed', 'Rajdhani', sans-serif",
        fontSize: '13px',
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
      }}>
        Authenticating…
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/auth" replace />
  }

  return children
}
